import AffirmPage from './affirm';
export default AffirmPage;
